/**
 * Races Slider Block
 */

import Swiper from 'swiper';
import { Navigation, Mousewheel } from 'swiper/modules';

export function initRacesSlider() {
    const racesSliders = document.querySelectorAll('[data-races-slider]');
    
    if (!racesSliders.length) return;
    
    racesSliders.forEach(slider => {
        const swiper = new Swiper(slider.querySelector('.swiper'), {
            modules: [Navigation, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 10,
            slidesOffsetBefore: 20, 
            initialSlide: 0,
            centeredSlides: false,
            slidesPerGroup: 1,
            touchEventsTarget: 'container',
            loop: false,
            simulateTouch: true,
            allowTouchMove: true,
            touchMoveStopPropagation: false,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
            },
            
            navigation: {
                nextEl: slider.querySelector('.slider-next'),
                prevEl: slider.querySelector('.slider-prev'),
            },
            
            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 420,  
                },
            }
        });
    });
}